<div>
  <div v-for="(num, idx) in formCount">
    <formly-form :fields="subFields" :model="subModels[idx]" :form="subForms[idx]" tag="div"></formly-form>
    <button @click.prevent="removeRow(idx)" type="button" class="btn btn-primary">x</button>
  </div>
  <button @click.prevent="addRow" type="button" class="btn btn-primary">{{addRowText}}</button>
</div>